import moment from 'moment';

const hasSameNumbers = (resultNumbers, betAckNumbers) => {
	if(!Array.isArray(resultNumbers) || !Array.isArray(betAckNumbers)) {
		return false;
	}

	if(resultNumbers.length !== betAckNumbers.length) {
		return false;
	}

	return resultNumbers.every((number, index) => number === betAckNumbers[index]);
};

const hasSameBetAmount = (resultBet, betAckBet) => {
	const resultValue = Number(resultBet);
	const betAckValue = Number(betAckBet);

	if(Number.isNaN(resultValue) || Number.isNaN(betAckValue)) {
		return false;
	}

	return Math.abs(resultValue - betAckValue) < 0.0001;
};

export const isBetAckForResult = (result, betAckData) => {
	if(!result || !betAckData?.createdTime) {
		return false;
	}

	if(result.ticket_id && betAckData.ticketId) {
		return result.ticket_id === betAckData.ticketId;
	}

	const hasSameUsername = !result.username || !betAckData.username || result.username === betAckData.username;

	return result.round_id === betAckData.roundId &&
		hasSameUsername &&
		hasSameBetAmount(result.bet, betAckData.bet) &&
		hasSameNumbers(result.numbers, betAckData.numbers);
};

export const getBetCreatedDateTime = (result, betAckCreatedTimes) => {
	const betAckData = betAckCreatedTimes?.find((item) => isBetAckForResult(result, item));
	const createdTime = result?.created_time || betAckData?.createdTime;
	const createdTimeWithoutMicroseconds = createdTime?.split('.')[0];
	const createdAt = moment.utc(
		createdTimeWithoutMicroseconds,
		'YYYY-MM-DD HH:mm:ss',
		true
	).local();

	if(!createdAt.isValid()) {
		return {
			date: result?.date || '',
			time: result?.time || '',
		};
	}

	return {
		date: createdAt.format('YYYY-MM-DD'),
		time: createdAt.format('HH:mm'),
	};
};

export const enrichAllBetsItemWithBetAck = (item, betAck) => {
	const ticketId = betAck.ticket_id || betAck.ticketId;
	const roundId = betAck.round_id || betAck.roundId;
	const createdTime = betAck.created_time || betAck.createdTime;
	const sameTicket = item.ticket_id && ticketId && item.ticket_id === ticketId;
	const sameRoundAndNumbers = item.round_id === roundId &&
		hasSameNumbers(item.numbers, betAck.numbers);

	if(sameTicket || sameRoundAndNumbers) {
		return {
			...item,
			created_time: createdTime,
			ticket_id: ticketId || item.ticket_id,
		};
	}

	return item;
};
